export default __webpack_public_path__ + "fb69dc7c2cb1193377c0575c83e34e01.png";